import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    alignItems: 'center',
    minHeight: 50,
    width: '100%',
    paddingLeft: '10px',
    backgroundColor: 'white',
  },
  center: {
    flexGrow: 1,
    margin: '10px',
    display: 'flex',
    justifyContent: 'center',
  },
  justify: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'center',
    alignItems: 'center',
    padding: '5px',
    '& > button': {
      background: 'red',
      color: 'white'
    },
  },
  root: {
    marginTop: '8px',
    width: '100%',
    borderRadius: '9px',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: '85vh',
  },
}));

export default useStyles
